import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UtilService, VwoService } from '../../../../shared/services';
import { IFundraiser } from '../../../../fundraiser/models/fundraiser.model';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent implements OnInit {

  @Input() public fundraiser: IFundraiser;
  @Input() public theaterImg;
  @Input() public isFundraiserEnded;
  @Output() public watchVideo = new EventEmitter();
  isMobile: any;
  today = new Date();
  constructor(
    public utilService: UtilService,
    public vwo: VwoService
  ) { }

  ngOnInit() {
    this.isMobile = this.utilService.isMobile();
  }

  /**Scroll to appealing video section */
  scrollToVideo() {
    this.watchVideo.emit(true);
  }

  getTheaterImage() {
    if (this.fundraiser) {
      if (this.isMobile) {
        return this.fundraiser.leaderboard ? this.fundraiser.leaderboard.cdn_path : '';
      } else {
        return this.fundraiser.theater ?
          this.fundraiser.theater.cdn_path :
          this.fundraiser.leaderboard ? this.fundraiser.leaderboard.cdn_path : '';
      }
    }
  }

}
